var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _g2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserFirefoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6195 34.5741C27.7998 34.5741 35.2419 27.1272 35.2419 17.941C35.2419 8.75476 27.7998 1.30786 18.6195 1.30786C9.43919 1.30786 1.99707 8.75476 1.99707 17.941C1.99707 27.1272 9.43919 34.5741 18.6195 34.5741Z",
    fill: "#110070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6196 34.2601C27.6264 34.2601 34.9278 26.9537 34.9278 17.9408C34.9278 8.92796 27.6264 1.62158 18.6196 1.62158C9.61275 1.62158 2.31128 8.92796 2.31128 17.9408C2.31128 26.9537 9.61275 34.2601 18.6196 34.2601Z",
    fill: "url(#paint0_radial_88_2132)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 26.3646C16.2601 26.2763 16.0401 26.0195 15.8719 25.9619C15.7038 25.9045 15.5389 26.2097 15.4309 25.7031C15.0763 25.9068 14.9233 25.6472 14.9233 25.6472C14.9233 25.6472 14.5411 25.6697 14.4668 26.1377C14.2849 26.3534 13.8183 27.1367 14.066 26.3219C14.3155 25.502 13.8028 26.2575 13.7553 26.6695C13.6664 26.8523 13.5159 26.8706 13.6104 26.0482C13.2819 25.9346 13.1137 25.1721 13.294 25.1575C13.0848 24.8659 13.249 24.4201 13.4234 24.4437C13.5978 24.4662 13.8967 24.0629 13.8877 23.9689C13.8784 23.8759 14.0224 23.9425 14.0137 23.3145C14.0044 22.6853 14.2508 22.5292 14.2711 23.0557C14.2922 23.58 14.6055 22.8839 14.5734 22.6167C14.5408 22.3512 14.6044 21.7499 14.7956 22.1054C14.5734 21.2265 14.7486 21.1922 14.8819 21.7769C15.2164 21.8033 15.2279 21.9814 15.2279 21.9814C15.5977 21.8902 15.7749 22.1689 15.8039 22.3253C16.1464 21.9209 16.4929 22.3571 16.4929 22.3571C16.4929 22.3571 16.7317 22.2778 16.6175 22.6932C16.5025 23.1072 17.1139 22.8833 16.968 22.5858C17.2684 22.4336 17.7147 22.8943 17.8553 23.209C17.9959 23.5249 17.6143 23.9718 17.9119 24.0798C18.2108 24.1872 18.0798 24.7075 18.0798 24.7075C18.0798 24.7075 18.7053 25.0546 18.271 25.3524L18.1234 25.7068C18.1234 25.7068 18.4063 26.0224 18.5028 25.8345C18.5989 25.6463 18.633 26.0257 18.633 26.0257C18.597 25.9588 18.7024 26.4169 19.0925 26.5131C19.484 26.6088 19.7318 27.2278 19.2973 27.2351C18.8642 27.2424 18.8307 27.2306 18.7134 27.4834C18.5964 27.7352 18.0438 27.7442 17.7572 27.4182C17.4526 27.5214 16.9109 27.3884 17.0704 27.1448C16.8077 27.2981 16.5596 26.8866 16.7646 26.7027C16.9699 26.5202 16.6493 26.2834 16.5416 26.5452C16.435 26.8073 15.868 26.9364 15.9077 26.4906C15.9195 26.3584 16.2215 26.2811 16.2252 26.3916C16.2806 26.519 16.3031 26.3812 16.2803 26.3646Z",
    fill: "url(#paint1_radial_88_2132)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7651 13.6102C29.8514 13.6963 30.0221 13.6769 30.1164 13.6507C30.2111 13.6234 30.1979 13.5562 30.2798 13.5298C30.3602 13.5025 30.6713 13.6507 30.59 13.9736C30.4015 13.9998 30.3329 14.229 30.3329 14.229C30.3329 14.229 30.1442 14.3094 30.0489 14.2695C29.9544 14.229 29.9544 14.2422 29.8191 14.2551C29.6838 14.2695 29.3587 14.0813 29.7105 14.0813C30.0626 14.0813 29.6706 13.9193 29.5215 13.9193C29.373 13.9193 29.4945 13.7714 29.6709 13.8122C29.5482 13.6102 29.616 13.4614 29.7651 13.6102Z",
    fill: "url(#paint2_radial_88_2132)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5455 14.3407C28.4513 14.4344 28.5596 14.7173 28.6811 14.7035C28.802 14.6903 28.9919 14.6366 28.9919 14.6366C28.9919 14.6366 29.0861 14.8247 28.9919 14.879C28.8977 14.9325 28.6223 14.9088 28.9789 15.0405C29.344 15.1746 29.4382 15.1341 29.4652 15.0666C29.4928 15 29.6137 14.7713 29.6821 14.7851C29.7361 14.6642 29.4928 14.5564 29.6281 14.4752C29.7625 14.3944 29.6553 14.0991 29.6553 14.0991C29.6553 14.0991 29.4655 14.1123 29.3845 14.2471C29.3032 14.3815 29.1958 14.2338 29.1145 14.2338C29.1032 14.2875 29.0799 14.3378 29.0464 14.3812L28.9927 14.2594C28.9922 14.2597 28.613 14.2465 28.5455 14.3407Z",
    fill: "url(#paint3_radial_88_2132)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0181 14.5623C26.0063 14.5278 26.1255 14.3883 26.0937 14.5688C26.0203 14.6973 26.3902 14.8127 26.494 14.6698C26.8413 14.1936 26.166 13.963 25.873 14.1843C25.5774 14.4077 25.4142 13.929 25.754 13.8606C26.0926 13.7923 26.1213 13.18 25.7481 13.1778C26.0774 13.0152 25.6212 12.5281 25.2441 12.4451C25.1831 11.9214 24.6307 11.5884 24.3401 11.7783C24.0468 11.9689 24.0218 11.9358 23.5917 11.6745C23.1637 11.4149 22.9575 12.2145 23.2725 12.5643C23.5892 12.9162 23.3594 13.4832 23.3724 13.3864C23.3724 13.3864 23.2531 13.601 23.261 13.6812C22.8985 13.8041 22.7927 13.2939 22.5677 13.1808C22.4037 13.3946 22.1394 13.5088 22.1394 13.5088L22.1591 13.0737C22.1591 13.0737 21.0338 12.4608 20.6881 12.6324C20.262 12.7638 20.1613 13.7504 20.5481 13.8949C20.9356 14.0409 20.0621 14.4043 20.9384 15.3279C21.8384 16.2766 22.1866 16.3036 22.37 16.1492C22.4156 16.1103 22.494 16.0521 22.5896 15.9872C22.5984 16.0237 22.613 16.0586 22.6355 16.0918C22.8608 16.4304 22.1118 16.6976 22.0075 17.1828C21.9014 17.6733 21.9993 18.5853 22.4434 18.6166C22.5281 18.1303 23.3594 18.3021 22.9069 18.7426C22.4465 19.1914 22.7696 19.2708 22.7696 19.2708C22.7696 19.2708 22.7913 20.112 23.4958 19.8431C23.4753 19.8912 23.459 19.9528 23.4489 20.02C23.252 19.9803 22.7708 19.9199 22.6529 20.2557C22.5044 20.6793 21.8758 20.112 21.4357 20.3024C20.9981 20.4911 20.3588 21.111 20.5742 21.5469C20.9876 21.3509 21.3041 22.2351 20.7266 22.0537C20.147 21.8718 20.2595 22.2168 20.2595 22.2168C20.2595 22.2168 19.6559 22.693 20.221 23.1995C20.0041 23.233 19.6182 23.4746 19.7482 24.005C19.7482 24.005 19.5004 24.0138 19.4669 24.4885C18.6578 24.6516 18.7073 24.9025 19.9242 24.6274C19.4332 24.882 20.2677 25.0023 20.6375 24.9683C21.0079 24.9346 21.9799 25.4138 21.2495 25.4189C20.518 25.4234 20.7356 25.7814 21.6123 25.7983C22.4873 25.8163 22.3953 26.0191 22.5252 26.0103C22.6552 26.0011 23.2208 26.4474 23.1904 26.6949C23.1586 26.9424 23.783 27.1995 24.1891 26.9157C24.2099 27.1733 25.2778 26.9725 25.4359 26.5082C26.5924 26.6848 26.5657 26.4691 26.3083 26.3321C25.7292 26.2438 24.6667 25.4737 25.819 25.87C26.9656 26.2652 25.8609 25.5587 25.5588 25.2873C24.9004 25.1593 24.8669 24.6106 24.8669 24.6106C24.8669 24.6106 25.2306 24.4036 24.9437 23.8861C25.6547 23.7542 25.2252 23.5041 25.3051 23.2653C25.385 23.0263 25.7461 22.7214 25.8699 22.6969C25.8932 22.6649 26.087 22.7034 25.9073 22.7765C25.752 22.7779 25.8623 23.215 26.0479 23.2375C26.6756 23.3137 26.4923 22.4939 26.1233 22.3291C25.7534 22.1628 26.0856 21.7117 26.3452 22.0155C26.6048 22.3187 27.1839 21.9781 26.9665 21.5942C27.3118 21.8335 27.498 21.0592 27.3509 20.6151C27.8127 20.2149 27.7976 19.417 27.4406 19.2381C27.2649 19.1504 27.1802 19.0938 27.1375 18.9847C27.3495 18.8846 27.6308 18.8106 27.7413 18.9093C27.9207 19.0716 28.4205 18.6242 28.3887 18.101C28.5991 18.2163 28.9341 17.1501 28.6495 16.7769C29.3011 15.8659 29.1256 15.7833 28.9076 15.936C28.5797 16.3905 27.5031 16.9338 28.3378 16.1286C29.1478 15.347 28.1221 15.9399 27.7793 16.067C27.3754 16.5724 26.9473 16.3294 26.9473 16.3294C26.9473 16.3294 26.9653 15.9154 26.4439 15.9067C26.6849 15.2421 26.2968 15.482 26.1607 15.3009C26.0254 15.1187 25.9762 14.6754 26.0181 14.5623Z",
    fill: "url(#paint4_radial_88_2132)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5695 7.90237C17.4686 8.16618 17.8994 8.59453 18.116 8.45671C18.3331 8.31749 18.6439 8.04131 18.6439 8.04131C18.6439 8.04131 18.9735 8.30624 18.8405 8.49496C18.7063 8.68312 18.1723 8.89462 18.9451 8.80884C19.7383 8.72137 19.8828 8.55768 19.8789 8.40637C19.8747 8.25562 19.9183 7.71506 20.0555 7.67737C20.0597 7.40006 19.5163 7.42565 19.7045 7.14834C19.8927 6.87215 19.4511 6.41821 19.4511 6.41821C19.4511 6.41821 19.1071 6.61959 19.0641 6.94696C19.0208 7.27406 18.699 7.09771 18.5466 7.17281C18.5863 7.33649 18.5393 7.51228 18.5393 7.51228L18.3402 7.33621C18.3402 7.33621 17.6196 7.66359 17.5695 7.90237Z",
    fill: "url(#paint5_radial_88_2132)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8591 21.7482C18.7648 21.8419 18.8728 22.1243 18.9941 22.1113C19.1158 22.0975 19.3051 22.0441 19.3051 22.0441C19.3051 22.0441 19.3996 22.2323 19.3051 22.2863C19.2103 22.3397 18.9356 22.3166 19.2916 22.4474C19.6564 22.5818 19.7515 22.5416 19.7785 22.4747C19.8055 22.4075 19.927 22.1785 19.9947 22.1918C20.0493 22.0711 19.8055 21.9634 19.9405 21.8832C20.076 21.8017 19.9686 21.5063 19.9686 21.5063C19.9686 21.5063 19.779 21.5196 19.6977 21.6543C19.6167 21.7887 19.5085 21.6405 19.4272 21.6405C19.4162 21.6942 19.3933 21.7447 19.3603 21.7884L19.306 21.6675C19.3054 21.6675 18.9263 21.654 18.8591 21.7482Z",
    fill: "url(#paint6_radial_88_2132)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88_2132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 33,
    height: 34
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6196 34.2601C27.6264 34.2601 34.9278 26.9537 34.9278 17.9408C34.9278 8.92796 27.6264 1.62158 18.6196 1.62158C9.61275 1.62158 2.31128 8.92796 2.31128 17.9408C2.31128 26.9537 9.61275 34.2601 18.6196 34.2601Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88_2132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9851 1.58809C18.73 1.64518 19.1569 2.56965 19.1569 2.56965C19.1569 2.56965 19.1417 3.19037 19.2469 3.22187C19.3518 3.25365 20.0457 3.4269 20.4085 3.87915C20.7733 4.33084 20.5837 4.56906 20.2802 4.43828C19.9765 4.30834 20.0569 4.70715 20.0569 4.70715C20.0569 4.70715 20.9732 5.00499 20.2814 4.98587C19.5878 4.96759 20.7482 5.47384 20.6715 5.52671C20.5947 5.58015 20.5514 5.87153 20.5514 5.87153C20.5514 5.87153 19.9396 5.92243 20.458 6.14012C22.2116 6.87868 20.2707 6.67928 20.2707 6.67928L20.0229 6.98387L20.5131 7.59868L20.89 7.86812C20.89 7.86812 21.6834 7.60346 21.9309 7.56212C22.1784 7.52134 22.8033 7.05362 22.8033 7.05362C22.8033 7.05362 22.9906 7.18777 22.8506 6.9144C22.7102 6.64102 23.3664 6.76281 23.5298 6.96643L24.688 7.48956C24.7037 7.53228 24.7323 7.56904 24.7698 7.59474C24.9957 7.75309 24.5656 8.02477 24.6092 8.31249C24.6528 8.59712 24.9152 9.0699 25.2035 9.02012C25.1532 8.74871 25.7221 8.71581 25.5241 9.01871C25.3264 9.31993 25.5458 9.31431 25.5458 9.31431C25.5458 9.31431 25.7286 9.7404 26.1153 9.50359C26.0999 9.63352 26.1792 9.89509 26.5113 9.91224C26.5113 9.91224 26.4762 10.0543 26.749 10.1547C26.7119 10.6412 26.8677 10.6567 26.9062 9.91759C26.9748 10.2422 27.1841 9.78568 27.2257 9.56743C27.2679 9.34806 27.7179 8.86599 27.5961 9.29209C27.4755 9.71453 28.9225 9.86893 29.0834 9.36465C29.2451 8.85615 29.8219 8.59093 29.8391 8.51387C29.8568 8.43512 28.5555 8.31418 28.6992 8.37549C28.8432 8.43652 29.1109 8.11027 29.0114 7.81918C29.1728 7.85181 29.244 7.17456 28.988 6.99934C29.3084 6.32546 29.1705 6.30437 29.0392 6.43852C28.8795 6.77602 28.2205 7.28537 28.6674 6.6579C29.1182 6.02396 28.4843 6.57859 28.2644 6.7164C28.0714 7.09159 27.7325 7.01874 27.7325 7.01874C27.7325 7.01874 27.6704 6.76337 27.3075 6.84887C27.3497 6.39718 27.1247 6.61431 26.994 6.52571C26.9141 6.47143 26.8376 6.34993 26.7903 6.24559C27.1028 6.37215 27.5221 6.50687 27.4499 6.27484C27.4029 6.12268 28.0413 6.45484 28.0635 6.38565L28.8617 6.27484L29.6371 5.78462C24.6795 1.35353 18.9851 1.58809 18.9851 1.58809Z",
    fill: "url(#paint7_linear_88_2132)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_88_2132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 33,
    height: 34
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6196 34.2601C27.6264 34.2601 34.9278 26.9537 34.9278 17.9408C34.9278 8.92796 27.6264 1.62158 18.6196 1.62158C9.61275 1.62158 2.31128 8.92796 2.31128 17.9408C2.31128 26.9537 9.61275 34.2601 18.6196 34.2601Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_88_2132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6154 3.01519C8.65351 4.34494 6.4187 7.08572 6.4187 7.08572C6.4187 7.08572 6.68139 7.68675 6.7728 7.64231C6.86533 7.59872 6.11158 9.219 6.66479 9.31013C7.22111 9.40153 8.82086 8.30775 8.52414 8.40844C8.22826 8.508 8.69092 7.81641 8.69092 7.81641C8.69092 7.81641 9.52342 7.44713 9.03095 7.87322C8.5427 8.2965 9.68036 7.92553 9.66264 8.01216C9.64464 8.09934 9.80945 8.33334 9.80945 8.33334C9.80945 8.33334 9.41936 8.75184 9.92308 8.58338C11.6519 8.00175 10.1509 9.08147 10.1509 9.08147L10.1804 9.44906L10.9283 9.57928L11.3704 9.53709C11.3704 9.53709 11.7571 8.85478 11.9067 8.66944C12.0566 8.48353 12.1947 7.74947 12.1947 7.74947C12.1947 7.74947 12.4195 7.72613 12.1351 7.61841C11.8502 7.51069 12.4071 7.17488 12.6633 7.2165L13.8685 6.84216C13.909 6.8628 13.9549 6.87083 14.0001 6.86522C14.276 6.83316 14.137 7.31409 14.3626 7.4955C14.5859 7.67578 15.0989 7.84988 15.2823 7.62713C15.0626 7.46063 15.471 7.06378 15.5233 7.41647C15.5756 7.76663 15.7382 7.61869 15.7382 7.61869C15.7382 7.61869 16.1705 6.87534 16.3086 6.44897C16.3842 6.55444 17.0896 5.52197 16.8759 5.0295C16.6599 4.53084 17.01 4.06144 16.9709 3.98859C16.931 3.91716 16.7198 4.13709 16.8759 4.08422C17.0331 4.0305 16.4306 4.3005 16.351 3.50681C16.2703 2.69738 16.1528 3.57488 16.0749 3.83447C16.1806 4.25691 17.2766 2.12756 17.2766 2.12756L18.6896 1.55128C18.6899 1.55213 15.4738 1.28297 11.6154 3.01519Z",
    fill: "url(#paint8_linear_88_2132)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3105 13.4212C23.0796 13.4212 26.9457 10.9164 26.9457 7.82656C26.9457 4.73673 23.0796 2.23193 18.3105 2.23193C13.5414 2.23193 9.67529 4.73673 9.67529 7.82656C9.67529 10.9164 13.5414 13.4212 18.3105 13.4212Z",
    fill: "url(#paint9_linear_88_2132)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8666 13.3772L35.4669 15.9405C35.4669 15.9405 34.896 11.195 34.1959 9.42056C33.123 6.702 32.6454 6.72394 32.6426 6.72816C33.3609 8.55431 33.2307 9.53531 33.2307 9.53531C33.2307 9.53531 31.9575 6.06525 28.5906 4.96106C24.6039 3.65437 22.573 4.12631 22.5879 4.14487C22.6031 4.16316 26.7085 4.86234 27.4366 5.86303C27.4366 5.86303 25.6926 5.86303 23.957 6.36281C23.8788 6.38531 30.3422 7.17028 31.6638 13.6292C31.6638 13.6292 30.9554 12.1507 30.079 11.8998C30.655 13.6528 30.5073 16.9794 29.9586 18.6329C29.8883 18.8458 29.8157 17.7135 28.7346 17.2267C29.0806 19.7076 28.7138 23.6434 26.9923 24.727C26.8581 24.8114 28.0714 20.8424 27.2364 22.3769C22.2507 30.0213 16.3233 25.4698 13.9189 23.8476C15.8489 24.3203 17.8983 23.98 19.0852 23.1686C20.2828 22.3496 20.991 21.7517 21.6274 21.8929C22.2633 22.0352 22.6869 21.397 22.1927 20.8309C21.6983 20.2633 20.4976 19.4837 18.8734 19.9089C17.7282 20.2087 16.3084 21.4763 14.1414 20.193C12.293 19.0975 12.3054 18.2082 12.3054 17.6418C12.3054 17.0748 12.8097 16.213 13.7274 16.3542C14.5492 16.4813 14.1161 15.9987 15.0006 16.3542C15.2416 16.4512 14.9764 15.1977 14.6336 14.3945C15.294 13.0163 17.436 12.6068 17.5957 12.4859C17.8854 12.2671 17.7262 12.1577 17.8249 11.8278C17.9175 11.5204 17.9765 10.6898 15.5791 10.9196C14.4758 11.0251 13.7741 9.5955 13.544 9.24872C13.6186 8.80659 13.7381 8.403 13.9004 8.03316C14.0646 7.6965 14.2441 7.38769 14.4235 7.15397L14.5726 6.95681C14.9297 6.54 15.3688 6.18337 15.8953 5.8875C16.1701 5.73225 12.8223 5.87766 11.316 7.84078C10.9118 7.89366 10.3572 7.77694 9.73702 7.77694C8.96021 7.77694 8.34962 7.86188 7.78458 8.00362C7.69402 8.02669 7.54833 8.01403 7.36946 7.97184C6.87249 7.45659 5.4654 6.21853 5.40099 4.53891C5.40099 4.53891 3.35546 6.11109 3.66146 10.3968C3.63446 12.7674 2.93499 12.0899 2.57499 13.3761C2.40737 13.9855 2.82671 14.4445 2.82671 14.4625C2.82615 14.4718 3.32958 13.9175 3.32958 13.9175C3.32958 13.9175 0.157928 19.4128 4.25462 26.4283C7.78515 32.476 13.7105 35.1488 19.8586 34.6287C20.9506 34.5582 22.0346 34.3938 23.0984 34.1374C37.4238 30.6741 35.8666 13.3772 35.8666 13.3772Z",
    fill: "url(#paint10_linear_88_2132)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4969 9.04199C13.4969 9.04199 14.1159 10.7337 15.5045 10.7284C18.1538 10.7177 18.207 10.7548 18.2239 11.0766C18.2768 12.0573 17.7924 12.3785 17.6074 12.518C17.4215 12.6569 14.8992 14.1194 14.8064 14.5379C14.7139 14.9561 11.8958 10.5602 11.8958 10.5602L13.4969 9.04199Z",
    fill: "url(#paint11_linear_88_2132)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9072 10.8657C14.9072 10.8657 15.7679 11.9646 15.117 12.4042C14.3222 12.9411 16.2409 13.0581 16.9362 12.668C17.6314 12.2779 18.0586 11.7044 18.0828 11.6192C18.107 11.5337 18.3354 10.7633 16.8841 11.0319C15.9667 11.2015 15.6303 11.2406 14.9072 10.8657Z",
    fill: "url(#paint12_linear_88_2132)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6075 12.5181C17.7481 12.4118 18.0603 12.1994 18.1796 11.6743C18.0927 11.7095 18.0845 11.6096 17.9819 11.6529C16.0336 13.6855 15.9588 12.27 14.8954 12.5552C13.9262 12.8204 13.7083 13.1844 13.6675 13.2125L13.7111 13.2744C13.9904 13.4164 14.2578 13.8686 14.4592 14.2728C14.6558 14.5071 14.7877 14.6221 14.8065 14.5372C14.8991 14.1195 17.4222 12.657 17.6075 12.5181Z",
    fill: "url(#paint13_linear_88_2132)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05095 14.1328C2.65326 14.9676 0.10064 19.2811 4.26652 26.4603C8.34323 33.4873 15.3984 35.782 22.6015 34.2231C24.6577 33.7781 27.0284 32.1694 28.5395 30.9887C27.5686 28.5401 28.1432 28.6321 27.6229 28.9541C21.8205 32.5465 17.2077 29.0028 13.6375 28.55C0.503389 26.8855 3.09708 14.1069 3.09708 14.1069L3.05095 14.1328Z",
    fill: "url(#paint14_linear_88_2132)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.987 23.9803C15.2248 24.3513 17.9259 24.0315 19.0858 23.1686C19.8673 22.5875 20.4577 22.1494 20.9547 21.9663C20.0766 21.3697 20.0628 22.2152 18.2167 22.6427C14.3709 23.5348 12.5037 21.6077 12.5037 21.6077C12.7762 23.1326 13.7282 23.8751 14.1571 24.1389C14.0435 24.0382 13.9839 23.9792 13.987 23.9803Z",
    fill: "url(#paint15_linear_88_2132)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81699 30.9445C9.81699 30.9445 6.61553 27.3318 5.72171 23.2861C4.40406 22.0415 3.4689 20.9891 2.8479 20.228C3.20649 23.1069 4.67434 27.5765 9.81699 30.9445Z",
    fill: "url(#paint16_linear_88_2132)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14616 27.6635C7.14616 27.6635 4.93694 24.518 5.76523 21.8475C6.51054 19.4462 5.60688 20.8747 5.08123 21.3879C4.55051 21.9066 4.27741 19.8574 4.29119 19.6211L4.29091 19.6135C4.25744 19.6062 3.23904 24.5233 7.14616 27.6635Z",
    fill: "url(#paint17_linear_88_2132)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87311 24.9217C3.87311 24.9217 3.36939 18.5378 4.96155 17.6356C7.48999 16.2029 5.17249 16.5379 4.43927 16.9356C3.69846 17.3369 3.76708 14.6946 3.87171 14.4437C3.97436 14.1959 1.26227 16.9418 3.87311 24.9217Z",
    fill: "url(#paint18_linear_88_2132)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9343 6.13647C14.9343 6.13647 12.9329 8.16963 12.9478 8.17694C12.963 8.18397 13.0052 10.7861 13.0707 11.5238C13.3106 11.8073 14.0579 13.6495 13.4859 13.2406C12.9014 12.8232 13.3227 12.8142 13.3739 13.026V13.0364C13.3348 13.0547 11.9213 9.97666 14.9343 6.13647Z",
    fill: "#A40000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4132 4.57031C5.4132 4.57031 3.28583 6.20269 3.69223 10.6791C5.33895 9.20081 7.66742 8.09578 7.66742 8.09578C7.27676 7.84941 5.48436 6.41531 5.4132 4.57031Z",
    fill: "url(#paint19_linear_88_2132)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 9.46586L13.8515 13.4396C12.9299 9.5373 13.6383 7.19618 15.9078 5.91874C16.2436 5.72946 11.1664 5.98708 10.6562 9.46586Z",
    fill: "url(#paint20_linear_88_2132)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40488 19.2826C8.94994 15.8491 13.7281 16.354 13.7281 16.354C13.5152 16.5123 12.6965 16.6068 12.4622 17.2621C11.6882 19.4244 12.4265 24.148 17.2463 26.1291C17.7545 26.3386 7.59966 24.3564 8.40488 19.2826Z",
    fill: "url(#paint21_linear_88_2132)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1521 11.7674C18.1287 11.7632 18.1079 11.7638 18.0975 11.7778C18.0387 11.8566 17.8115 12.1246 17.2712 12.5653C16.2677 13.3815 15.8441 13.1748 15.0966 13.3422C14.7562 13.4184 14.4325 13.6468 14.2148 13.8298C14.3029 13.9722 14.3853 14.126 14.459 14.2731C14.6556 14.5074 14.7875 14.6224 14.8063 14.5375C14.8991 14.1195 17.4219 12.657 17.6073 12.5175C17.7395 12.4188 18.019 12.2225 18.1521 11.7674Z",
    fill: "url(#paint22_linear_88_2132)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0715 16.9578C15.0999 16.2322 15.0487 14.4699 14.2947 13.7052C13.7181 13.121 13.5831 12.4513 13.5058 11.6877C7.24091 14.028 6.34653 17.0869 6.97288 16.9876C11.9833 16.1928 13.3918 16.0958 15.0715 16.9578Z",
    fill: "url(#paint23_linear_88_2132)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71512 21.2453C1.71512 21.2453 2.15049 15.5885 4.98183 13.5185C7.20455 11.8923 5.47824 12.4829 4.62015 12.5504C3.71508 12.6218 3.23246 13.1725 3.40712 12.97L3.41583 12.9546C3.38574 12.9197 1.29099 14.6778 1.71512 21.2453Z",
    fill: "url(#paint24_linear_88_2132)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 16.8994C1.4165 16.8994 2.93385 12.083 6.00004 12.1241C8.03347 12.1511 6.4205 10.4053 5.80541 10.1401C5.1636 9.86535 5.01032 9.87603 4.86041 10.0088C4.63569 10.2079 2.61829 10.1311 1.4165 16.8994Z",
    fill: "url(#paint25_linear_88_2132)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1014 21.6138C22.332 21.3879 22.1714 20.5203 20.7222 19.9946C19.4073 19.5168 17.3548 20.7312 16.7458 20.9708C16.7458 20.9708 19.0707 20.5355 19.9423 20.6803C21.1241 20.8772 21.5389 22.1656 22.1014 21.6138Z",
    fill: "url(#paint26_linear_88_2132)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65648 20.0273C3.65648 20.0273 3.40476 15.2922 5.52651 13.27C7.19264 11.6818 5.82604 12.3579 5.12207 12.507C4.37957 12.6645 4.03926 13.1727 4.16217 12.9862L4.16751 12.9724C4.1391 12.9465 2.59392 14.6301 3.65648 20.0273Z",
    fill: "url(#paint27_linear_88_2132)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02222 18.5228C2.02222 18.5228 2.91884 13.8667 5.46584 12.4157C7.46581 11.2758 5.97659 11.6029 5.25715 11.5779C4.49862 11.552 4.04609 11.9632 4.21006 11.8116L4.21822 11.7998C4.1974 11.7674 2.29165 13.0291 2.02222 18.5228Z",
    fill: "url(#paint28_linear_88_2132)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04625 20.4341C5.04625 20.4341 4.55603 17.6118 5.61269 16.2227C6.45588 15.1143 5.71563 15.6562 5.32413 15.8163C4.91575 15.983 4.76106 16.3124 4.81675 16.1915C4.87047 16.0736 2.99875 17.524 5.04625 20.4341Z",
    fill: "url(#paint29_linear_88_2132)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60644 17.7729C5.60644 17.7729 5.11622 14.9506 6.1726 13.5612C7.01579 12.4528 6.27554 12.995 5.88404 13.1548C5.47566 13.3216 5.32069 13.6512 5.37666 13.5303C5.43066 13.4121 3.55922 14.8625 5.60644 17.7729Z",
    fill: "url(#paint30_linear_88_2132)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64307 13.9148C2.64307 13.9148 3.78832 11.5687 5.31016 11.1066C6.5246 10.7381 5.68816 10.7438 5.3141 10.6523C4.92316 10.5576 4.63319 10.7176 4.73866 10.6583C4.84188 10.6003 2.68525 10.672 2.64307 13.9148Z",
    fill: "url(#paint31_linear_88_2132)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47974 15.7714C2.47974 15.7714 3.6247 13.4252 5.14683 12.9634C6.36127 12.5949 5.52483 12.6 5.15049 12.5086C4.75955 12.4141 4.46958 12.5744 4.57533 12.5148C4.67827 12.4569 2.52164 12.5289 2.47974 15.7714Z",
    fill: "url(#paint32_linear_88_2132)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31104 15.2592C3.31104 15.2592 5.33069 11.1206 8.01579 10.3053C10.1586 9.65534 8.68319 9.66462 8.02254 9.50402C7.33263 9.33696 6.82132 9.62018 7.00722 9.51499C7.18919 9.41262 3.385 9.5389 3.31104 15.2592Z",
    fill: "url(#paint33_linear_88_2132)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69165 13.0303C4.69165 13.0303 5.94771 10.4563 7.61778 9.94923C8.95062 9.54479 8.03262 9.5507 7.62199 9.45085C7.19281 9.34707 6.87499 9.52285 6.99059 9.45732C7.10365 9.3932 4.73749 9.47195 4.69165 13.0303Z",
    fill: "url(#paint34_linear_88_2132)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10132 13.9397C5.10132 13.9397 6.24629 11.5935 7.76813 11.132C8.98285 10.7633 8.14641 10.7686 7.77207 10.6772C7.38085 10.5824 7.09088 10.7427 7.19663 10.6834C7.29929 10.6249 5.14322 10.6975 5.10132 13.9397Z",
    fill: "url(#paint35_linear_88_2132)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2245 11.0765C18.2113 10.8318 18.175 10.7522 17.0042 10.7319C17.1383 10.7927 17.3698 10.9147 17.6246 11.1237C17.961 11.3993 18.0155 11.7067 18.0504 12.0248C18.164 11.8086 18.2476 11.5093 18.2245 11.0765Z",
    fill: "url(#paint36_linear_88_2132)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.349 7.8086L10.3334 9.44267C10.3334 9.44267 6.27276 8.80564 2.82998 12.1362C2.54563 12.4113 5.08194 6.24682 11.349 7.8086Z",
    fill: "url(#paint37_linear_88_2132)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70215 10.7334C7.70215 10.7334 8.7844 8.72416 10.1876 8.11694C9.46221 8.13972 7.83349 8.70701 7.70215 10.7334Z",
    fill: "url(#paint38_linear_88_2132)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53833 12.6942C3.53833 12.6942 4.6833 10.348 6.20542 9.88596C7.41986 9.51752 6.58342 9.52286 6.20936 9.43146C5.81814 9.33696 5.52846 9.49727 5.63392 9.43736C5.73658 9.37971 3.57996 9.45142 3.53833 12.6942Z",
    fill: "url(#paint39_linear_88_2132)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93677 11.0409C5.93677 11.0409 7.1183 9.14979 8.52371 8.64636C7.81608 8.62301 6.19214 9.07357 5.93677 11.0409Z",
    fill: "url(#paint40_linear_88_2132)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96223 7.81069C7.96223 7.81069 7.07151 8.19994 5.50073 7.54688L6.90108 8.25112L7.96223 7.81069Z",
    fill: "url(#paint41_linear_88_2132)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5316 8.06066C7.5316 8.06066 6.34473 8.5205 4.05957 7.83594L6.01398 8.61359C6.25613 8.39 7.5316 8.06066 7.5316 8.06066Z",
    fill: "url(#paint42_linear_88_2132)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39807 7.68326C8.39807 7.68326 7.61029 7.92317 6.15454 7.36011L7.55488 8.06379C7.70282 7.93329 8.39807 7.68326 8.39807 7.68326Z",
    fill: "url(#paint43_linear_88_2132)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9409 8.58936C5.9409 8.58936 5.35534 9.07536 3.85571 9.09504L5.15256 9.13751L5.9409 8.58936Z",
    fill: "url(#paint44_linear_88_2132)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51636 11.0763C4.51636 11.0763 6.52026 8.46601 8.17036 7.8751C7.33926 7.84782 4.81589 8.76751 4.51636 11.0763Z",
    fill: "url(#paint45_linear_88_2132)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5525 15.5273C35.5525 15.5273 35.7685 20.3705 29.041 27.0982C28.2932 27.8458 24.2336 31.6489 24.3765 32.7896C24.4265 33.1932 35.0274 31.1637 35.5525 15.5273Z",
    fill: "url(#paint46_linear_88_2132)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5093 4.13575C30.6129 4.75844 32.1817 10.5851 32.1823 10.2282C32.2031 4.56409 24.4943 4.13378 22.5093 4.13575Z",
    fill: "url(#paint47_linear_88_2132)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9773 6.35083C24.9773 6.35083 30.595 7.49917 32.1793 13.4535C32.3894 14.2421 31.5023 8.6163 31.776 9.15039C32.0493 9.68702 29.5153 6.52886 24.9773 6.35083Z",
    fill: "url(#paint48_linear_88_2132)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2222 6.20532C27.2222 6.20532 32.2956 7.2631 32.346 15.3125C32.3814 21.01 33.2257 17.4514 34.0633 16.1711C34.7855 15.0647 34.292 13.7169 34.2745 13.7206C34.272 13.7212 33.9092 12.6718 34.1536 13.1165C34.1645 13.1362 33.813 12.8268 33.8152 12.8265C33.872 12.8178 33.6203 7.04063 27.2222 6.20532Z",
    fill: "url(#paint49_linear_88_2132)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9351 7.29565C32.9351 7.29565 34.7573 12.0426 32.826 14.4031C32.1957 15.1735 32.1251 19.1202 32.8952 18.7577C33.6672 18.3946 33.4996 20.8536 33.3983 21.1332L33.3966 21.1419C33.447 21.1734 37.2042 15.0745 32.9351 7.29565Z",
    fill: "url(#paint50_linear_88_2132)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4019 12.2932C30.4019 12.2932 31.5491 15.6519 30.3479 18.0529L31.2566 20.0822C31.9229 18.4453 32.7717 14.9828 30.4019 12.2932Z",
    fill: "url(#paint51_linear_88_2132)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4194 11.8938C32.4194 11.8938 33.2128 17.2246 30.3502 22.0371C30.3947 23.1503 30.1992 24.1577 29.9312 24.9877C30.056 25.1516 30.2228 25.2639 30.443 25.2835C30.346 25.3733 30.2492 25.4574 30.1556 25.537C29.984 25.6132 29.8077 25.693 29.637 25.7757L29.5281 26.0221C29.7442 25.8697 29.9534 25.7079 30.1553 25.5372C30.74 25.2788 31.2662 25.0785 31.2651 25.0771L30.9001 25.211C30.7265 25.274 30.5749 25.2954 30.443 25.2835C32.6534 23.269 35.6827 18.763 32.4194 11.8938ZM29.084 26.066C28.8315 26.2142 28.6475 26.3531 28.6084 26.4606C28.5792 26.5388 28.7516 26.4935 29.0494 26.3264C29.0649 26.2367 29.0776 26.1492 29.084 26.066Z",
    fill: "url(#paint52_linear_88_2132)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8885 17.5737C28.8885 17.5737 31.1455 23.9978 23.932 30.021C23.5065 30.3762 26.8601 30.2241 27.1535 30.091C28.018 29.6984 29.0398 27.0777 28.9192 27.391C28.7996 27.7046 32.2688 22.7591 28.8885 17.5737Z",
    fill: "url(#paint53_linear_88_2132)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0449 21.6484C32.0449 21.6484 30.6836 29.9808 21.2705 30.6515C17.585 30.9145 12.2927 30.0516 12.7616 31.4576C12.907 31.8932 13.5997 33.7107 15.1809 34.132C19.4598 35.2736 30.8445 34.8998 32.0449 21.6484Z",
    fill: "url(#paint54_linear_88_2132)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1947 27.9543C24.1947 27.9543 18.4353 29.27 14.7042 26.0938C11.2901 23.1871 12.9838 25.6334 13.447 26.8402C13.9226 28.078 11.2468 27.1325 10.8449 26.9333C10.4441 26.7367 17.1826 30.9628 24.1947 27.9543Z",
    fill: "url(#paint55_linear_88_2132)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4833 31.0932C20.4833 31.0932 13.613 29.7429 11.4378 25.0874C9.57899 21.1102 10.0709 24.0288 9.98708 25.3571C9.89905 26.7234 7.97249 24.8576 7.71514 24.533L7.70221 24.5212C7.66396 24.5463 11.2457 30.1614 20.4833 31.0932Z",
    fill: "url(#paint56_linear_88_2132)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9783 30.4914C12.9783 30.4914 9.69692 27.9497 8.21727 24.4645C6.97386 24.0325 5.32096 23.0453 5.28833 22.876C5.81342 25.5841 8.57867 28.7459 12.9783 30.4914Z",
    fill: "url(#paint57_linear_88_2132)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8474 3.33186) scale(29.1966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#66C2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#62B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#5CA8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#5392BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#4874AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3A5097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#2A2781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#1B006D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596AAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8425 5.27904) scale(14.6317 14.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8427 5.27904) scale(14.6315 14.6315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8418 5.27828) scale(14.6337 14.6337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0819 6.664) scale(16.0754 16.0754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#0B629B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#031747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00022F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8422 5.27831) scale(14.6334 14.6334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_88_2132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8427 5.2785) scale(14.6326 14.6326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_88_2132",
    x1: 22.1536,
    y1: 5.9559,
    x2: 26.877,
    y2: 6.35865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_88_2132",
    x1: 11.5422,
    y1: 6.67116,
    x2: 8.93195,
    y2: 10.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F80BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0A5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00145A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_88_2132",
    x1: 18.3105,
    y1: 10.9856,
    x2: 18.3105,
    y2: 4.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C4E0E3",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#C4E0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CDE5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#E8F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_88_2132",
    x1: 18.8222,
    y1: 17.0801,
    x2: 22.7409,
    y2: 14.7787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF731B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#DF731B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#EC8811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#F4950B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_88_2132",
    x1: 12.4802,
    y1: 11.6621,
    x2: 15.5219,
    y2: 11.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#941403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#E85C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_88_2132",
    x1: 7.60766,
    y1: 10.819,
    x2: 18.5885,
    y2: 12.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#941403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#A32104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#C84107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#DF5509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E85C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_88_2132",
    x1: 14.4111,
    y1: 13.7232,
    x2: 15.2866,
    y2: 13.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_88_2132",
    x1: 11.6198,
    y1: 24.4426,
    x2: 26.3472,
    y2: 25.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF731B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_88_2132",
    x1: 15.1241,
    y1: 22.1569,
    x2: 22.803,
    y2: 24.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF731B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_88_2132",
    x1: 2.56667,
    y1: 25.3572,
    x2: 10.0452,
    y2: 25.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5C01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_88_2132",
    x1: 5.43094,
    y1: 22.4972,
    x2: 7.97424,
    y2: 35.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_88_2132",
    x1: 4.43558,
    y1: 18.3439,
    x2: 3.80091,
    y2: 32.4337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_88_2132",
    x1: 5.89948,
    y1: 9.94894,
    x2: 4.3692,
    y2: 6.02775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#941403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#E85C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BD5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_88_2132",
    x1: 12.4422,
    y1: 10.8485,
    x2: 16.1091,
    y2: 6.02871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#F9BD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_88_2132",
    x1: 10.5038,
    y1: 17.4275,
    x2: 14.2208,
    y2: 24.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#941403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E35100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF731B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_88_2132",
    x1: 16.1181,
    y1: 12.8683,
    x2: 17.0462,
    y2: 13.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#EFA777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#F2B585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#F6CD9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCEEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_88_2132",
    x1: 10.7042,
    y1: 14.8555,
    x2: 14.9683,
    y2: 19.2067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#DF731B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#F9BD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_88_2132",
    x1: 4.57638,
    y1: 12.7892,
    x2: 0.51456,
    y2: 28.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_88_2132",
    x1: 4.99139,
    y1: 11.4379,
    x2: -1.01982,
    y2: 21.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C06E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_88_2132",
    x1: 23.4303,
    y1: 20.3133,
    x2: 17.6889,
    y2: 21.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#FFFAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#F5F89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F3ED91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#ECC267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#E6A046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#E2872E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#E07820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF731B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_88_2132",
    x1: 4.9941,
    y1: 12.5262,
    x2: 3.31068,
    y2: 25.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C06E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_88_2132",
    x1: 5.26659,
    y1: 11.4495,
    x2: 0.430805,
    y2: 23.8997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C06E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_88_2132",
    x1: 5.01394,
    y1: 17.5183,
    x2: 5.27023,
    y2: 24.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C072"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_88_2132",
    x1: 5.57368,
    y1: 14.8567,
    x2: 5.83003,
    y2: 21.5585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C072"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_88_2132",
    x1: 4.20879,
    y1: 11.9149,
    x2: 2.58119,
    y2: 14.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_88_2132",
    x1: 4.04546,
    y1: 13.7717,
    x2: 2.41814,
    y2: 16.8092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_88_2132",
    x1: 5.88925,
    y1: 12.4825,
    x2: 4.31622,
    y2: 16.3882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C072"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_88_2132",
    x1: 6.48743,
    y1: 10.5809,
    x2: 2.76762,
    y2: 16.1606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C072"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_88_2132",
    x1: 6.73791,
    y1: 11.7077,
    x2: 3.34716,
    y2: 16.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C072"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_88_2132",
    x1: 17.6479,
    y1: 10.9156,
    x2: 17.9165,
    y2: 11.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_88_2132",
    x1: 7.07882,
    y1: 9.28939,
    x2: 7.07882,
    y2: 7.81957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_88_2132",
    x1: 7.16763,
    y1: 10.9416,
    x2: 10.3847,
    y2: 7.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_88_2132",
    x1: 5.10377,
    y1: 10.6943,
    x2: 3.47617,
    y2: 13.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_88_2132",
    x1: 5.29796,
    y1: 11.079,
    x2: 8.65303,
    y2: 7.89734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_88_2132",
    x1: 4.48441,
    y1: 7.38875,
    x2: 8.03613,
    y2: 8.20645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_88_2132",
    x1: 2.71576,
    y1: 7.78166,
    x2: 7.81257,
    y2: 8.47972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_88_2132",
    x1: 5.20096,
    y1: 7.27134,
    x2: 8.46469,
    y2: 8.02263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_88_2132",
    x1: 5.01784,
    y1: 8.85429,
    x2: 2.02618,
    y2: 8.54745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_88_2132",
    x1: 3.75656,
    y1: 11.2827,
    x2: 8.37714,
    y2: 6.90118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_88_2132",
    x1: 25.5043,
    y1: 34.1869,
    x2: 33.6096,
    y2: 21.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_88_2132",
    x1: 30.2175,
    y1: 7.67725,
    x2: 24.91,
    y2: 5.34625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_88_2132",
    x1: 33.7827,
    y1: 12.9976,
    x2: 26.3523,
    y2: 6.09967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_88_2132",
    x1: 31.5748,
    y1: 12.598,
    x2: 28.3735,
    y2: 9.46762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_88_2132",
    x1: 32.5369,
    y1: 16.949,
    x2: 34.2879,
    y2: 10.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_88_2132",
    x1: 31.2861,
    y1: 18.3572,
    x2: 31.0344,
    y2: 13.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_88_2132",
    x1: 30.2706,
    y1: 22.2952,
    x2: 32.9774,
    y2: 15.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_88_2132",
    x1: 27.0288,
    y1: 27.6187,
    x2: 26.9637,
    y2: 20.7209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#FEFE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#FFFE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#FFFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FFFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FFFF92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_88_2132",
    x1: 17.1105,
    y1: 33.2042,
    x2: 30.4187,
    y2: 25.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9120D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#BB180D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#C0290C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#C8450A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#D36C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#E29E05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#F4DA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FEFD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#FEFD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#FEFD1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#FEFE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#FFFE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFFFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_88_2132",
    x1: 16.2295,
    y1: 27.2051,
    x2: 29.6118,
    y2: 30.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_88_2132",
    x1: 11.901,
    y1: 26.0463,
    x2: 26.8517,
    y2: 33.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_88_2132",
    x1: 7.05139,
    y1: 24.6379,
    x2: 17.0496,
    y2: 37.4586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#DE7210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C08F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserFirefoxIcon);
export default __webpack_public_path__ + "static/media/browser_FirefoxIcon.2cd2d341e7c2127aa8502d49e656842e.svg";
export { ForwardRef as ReactComponent };